'use strict';

var is = {
  array: function array(obj) {
    return _typeOf(obj) === 'array';
  },
  regexp: function regexp(obj) {
    return _typeOf(obj) === 'regexp';
  },
  object: function object(obj) {
    return _typeOf(obj) === 'object';
  },
  error: function error(obj) {
    return _typeOf(obj) === 'error';
  },
  date: function date(obj) {
    return _typeOf(obj) === 'date';
  },
  number: function number(obj) {
    return _typeOf(obj) === 'number';
  },
  string: function string(obj) {
    return _typeOf(obj) === 'string';
  },
  boolean: function boolean(obj) {
    return _typeOf(obj) === 'boolean';
  },
  email: function email(email) {
    var emailRE = /^(([^<>()[\].,;:\s@"]+(.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    return emailRE.test(email || '');
  },
  iphone: function iphone() {
    return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
  }
};

function _typeOf(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-z|A-Z]+)/)[1]
    .toLowerCase();
}

blz.utils.is = is;
module.exports = is;
